(() => {
  function getBottom() {
    var el = document.querySelector('.section-header');
    return el ? el.getBoundingClientRect().bottom : null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.cio-filters-modal-button')) return;

    var tries = 0;
    var timer = setInterval(function () {
      var bottom = getBottom();
      var modal = document.querySelector('.cio-product-tiles-container .cio-mobile-modal-container');
      if (modal && bottom != null) {
        modal.style.top = bottom + 'px';
        modal.style.height = 'calc(100% - ' + bottom + 'px)';
        clearInterval(timer);
      }
      if (++tries >= 10) clearInterval(timer);
    }, 50);
  });
})();

